import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const createLanguage = (destionationLanguage) => {
  console.log(
    'destionationLanguage--->',
    destionationLanguage
  );

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_CREATE_LANGUAGE}`,
    true,
    {
      DistinitationLanguage: destionationLanguage,
    }
  );
};
